import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { Pier } from '@shared/models/pier';

@Component({
    selector: 'bcm-pier-link',
    templateUrl: './pier-link.component.html',
    standalone: false
})
export class PierLinkComponent implements OnChanges {

    @Input()
    public pier!: Pier;

    @Input()
    public dataTest: string;

    @Input()
    public additionalInfo: string;

    @Input()
    public disableLink: boolean;

    public viewData: string;

    @Output()
    public clicked = new EventEmitter<void>();

    ngOnChanges(): void {
        const pier = this.pier;

        this.viewData = [
            (pier?.handle || null),
            this.additionalInfo,
        ]
            .filter(item => item != null)
            .join(' - ');
    }

    click(event): void {
        this.clicked.emit();
        event.stopPropagation();
    }
}
